(function() {
    "use strict";

    angular.module('eSign')
        .service('sessionService', ['$http', 'appConfig', function($http, appConfig) {

            var baseUrl = appConfig.sessionApiUrl;

            this.setCurrentSignTaskId = function(signTaskId) {
              return $http.post(baseUrl + '/SetCurrentSignTaskId', { signTaskId: signTaskId });
            };

            this.setCurrentSignTaskInfo = function (signTaskId, externalRef) {
                return $http.post(baseUrl + '/SetCurrentSignTaskInfo', { signTaskId: signTaskId, externalRef: externalRef });
            };

            this.setCurrentApplicationNumber = function (applicationNumber, offerInsurance) {
                return $http.post(baseUrl + '/SetCurrentApplicationNumber', { 'applicationNumber': applicationNumber, 'offerInsurance': offerInsurance });
            };

            this.setCurrentDocumentReference = function(ref) {
              return $http.post(baseUrl + '/SetCurrentDocumentReference', { documentReference: ref });
            };

            this.isSignedIn = function() {
                return $http.get(baseUrl + '/IsSignedIn');
            };

            this.NumberOfSignTasks = function () {
                return $http.get(baseUrl + '/NumberOfSignTasks');
            };

            this.logout = function() {
                return $http.post(baseUrl + '/Logout');
            };

            this.getSettings = function () {
                return $http.get(baseUrl + '/Settings');
            };

        }]);
}());
